import { createSlice } from '@reduxjs/toolkit';
import { getBreachImpactList } from './thunk';

const getOptionLabel = item => item?.name || item?.label || item?.description || item?._id || '';

export const initialState = {
	breachImpactList: [],
	breachImpactListSelect: [],
	isLoadingList: false,
	isSuccess: false,
};

const BreachImpactSlice = createSlice({
	name: 'BreachImpact',
	initialState,
	reducers: {},
	extraReducers: builder => {
		builder.addCase(getBreachImpactList.pending, state => {
			state.isLoadingList = true;
			state.isSuccess = false;
		});

		builder.addCase(getBreachImpactList.fulfilled, (state, action) => {
			const breachImpactList = action.payload || [];
			state.breachImpactList = breachImpactList;
			state.breachImpactListSelect = breachImpactList.map(item => ({
				item,
				value: item._id,
				label: getOptionLabel(item),
			}));
			state.isLoadingList = false;
			state.isSuccess = true;
		});

		builder.addCase(getBreachImpactList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isSuccess = false;
		});
	},
});

export default BreachImpactSlice.reducer;
